import {
  GetListParams,
  GetListResult,
  GetOneParams,
  GetOneResult,
  RaRecord,
  UpdateParams,
  UpdateResult,
} from "react-admin";
import { getJson, putJson } from "../../../utils/api";
import IHandler from "./IHandler";

const getChangedData = (
  data: Record<string, any>,
  previousData: Record<string, any>
): Record<string, any> => {
  const changedData: Record<string, any> = {};

  for (const key in data) {
    if (data[key] === null && data[key] !== previousData[key]) {
      changedData[key] = data[key];
      continue;
    }

    if (typeof data[key] === "object" && key !== "comments") {
      continue;
    }

    if (data[key] !== previousData[key]) {
      changedData[key] = data[key];
      continue;
    }
  }

  return changedData;
};

export default class UserHandler implements IHandler {
  static route = "/admin/profiles";
  static resourceIdName = "user_id";

  static async getListHandler<RecordType extends RaRecord = any>(
    resource?: string,
    params?: GetListParams
  ): Promise<GetListResult<RecordType>> {
    const page = params?.pagination.page ?? 1;

    const query: { [key: string]: any } = {
      page_size: params?.pagination.perPage ?? 10,
      page,
      ...params?.filter,
    };

    return getJson(
      `${this.route}?${new URLSearchParams(query).toString()}`
    ).then(async (response) => {
      let responseData = await response.json();

      responseData = responseData?.length > 0 ? responseData : [];

      let idx = 1;

      responseData = responseData.map((data: any) => {
        const result = {
          idx,
          ...data,
        };

        idx++;

        result.id = data[this.resourceIdName];
        delete result[this.resourceIdName];

        return {
          ...result,
        };
      });

      return {
        data: responseData,
        pageInfo: {
          hasNextPage: true,
          hasPrevPage: page > 1,
        },
      };
    });
  }

  static async getOneHandler<RecordType extends RaRecord = any>(
    resource: string,
    params?: GetOneParams<any>
  ): Promise<GetOneResult<RecordType>> {
    const id = params?.id;
    return UserHandler.getListHandler("admin/profiles", {
      filter: { user_id: id },
      pagination: { page: 1, perPage: 1 },
      sort: { field: "user_id", order: "ASC" },
    }).then(async (response) => ({ data: response.data[0] }));
  }

  static async updateHandler<RecordType extends RaRecord = any>(
    resource: string,
    params?: UpdateParams<any>
  ): Promise<UpdateResult<RecordType>> {
    const id = params?.id;
    const payload = params?.data || {};
    const previousPayload = params?.previousData || {};
    const changedData = getChangedData(payload, previousPayload);

    return putJson(`${this.route}/${id}`, changedData)
      .then(async (response) => {
        const { data } = await response.json();

        data.id = data[this.resourceIdName];
        delete data[this.resourceIdName];

        return {
          data: {
            ...data,
            id: "",
          },
        };
      })
      .catch((response) => {
        return Promise.reject({
          status: response.status,
          error: response.statusText,
          message: response?.error?.errorMessage ?? response.statusText,
        });
      });
  }
}
